module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("dYrW9"))).then(() => parcelRequire('ikE14'));